/* ACTIONS BUTTONS */
import { useDispatch, useSelector } from 'react-redux';
import React, { useState, createRef, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  StepperNav,
} from 'design-react-kit';
import { Icon } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { prenotazioneSteps } from '@redturtle/volto-io-prenoto/helpers';

const messages = defineMessages({
  button_prev: {
    id: 'booking_button_prev',
    defaultMessage: 'Indietro',
  },
  button_next: {
    id: 'booking_button_next',
    defaultMessage: 'Avanti',
  },
});

const PrenotazioneStepperActions = ({
  activeStep,
  setActiveStep,
  disabled = false,
  scrollToTop,
}) => {
  const intl = useIntl();

  const { STEPS } = prenotazioneSteps();

  return (
    <Col xs="12" lg={{ size: 8, offset: 4 }}>
      <StepperNav className="px-0 pt-3 mt-0">
        <ul className="navbar-nav">
          {/* PREV BUTTON */}
          {activeStep !== 0 && (
            <li className="nav-item">
              <Button
                color="link"
                size="sm"
                className="steppers-btn-prev ms-0 ps-0 pe-2"
                onClick={() => {
                  setActiveStep(activeStep - 1);
                  scrollToTop();
                }}
              >
                <Icon
                  icon="it-chevron-left"
                  color="primary"
                  size="sm"
                  className="d-inline"
                />
                {intl.formatMessage(messages.button_prev)}
              </Button>
            </li>
          )}

          {/* NEXT BUTTON */}
          {activeStep !== STEPS.length - 1 && (
            <li className="nav-item">
              <Button
                color="primary"
                size="sm"
                className="ms-auto me-0 steppers-btn-confirm"
                disabled={disabled}
                onClick={() => {
                  setActiveStep(activeStep + 1);
                  scrollToTop();
                }}
              >
                {intl.formatMessage(messages.button_next)}
                <Icon icon="it-chevron-right" size="sm" className="d-inline" />
              </Button>
            </li>
          )}
        </ul>
      </StepperNav>
    </Col>
  );
};

export default PrenotazioneStepperActions;
